module.exports = __webpack_public_path__ + "static/img/BudgIT.315644f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/BudgIT.png
// module id = UAHg
// module chunks = 0